module.exports = __webpack_public_path__ + "img/PVMonitoringService.d1565ec7.png";